// extracted by mini-css-extract-plugin
export default {"timeSlotsDropdown":"V5U8jW"};